var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CFCFCF;}\n\t.st1{fill:none;stroke:#BABABA;stroke-width:2.4703;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#F2F2F2;}\n\t.st3{fill:#D2D2D2;}\n\t.st4{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.4703;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:none;stroke:#BABABA;stroke-width:1.6798;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:#BABABA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.6,205.6c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4 C160.2,204.5,161.3,205.6,162.6,205.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.3,23.4V34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87,28.7h10.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M213.2,90.4c-20.7,0-41.7-0.8-61.4-6.3c-19.3-5.4-37.1-15.8-52.9-27.8c-10.4-7.8-19.8-14.1-33.2-13.1 c-13.1,0.7-25.7,5.6-35.9,14c-17.1,15-14.5,42.7-7.7,62.1c10.3,29.3,41.6,49.8,68.1,63c30.7,15.3,64.4,24.3,98.3,29.4 c29.6,4.5,67.7,7.8,93.4-11.6c23.6-17.8,30.1-58.4,24.3-85.8c-1.4-8.1-5.7-15.4-12.1-20.6c-16.6-12.1-41.3-4-59.9-3.6 C227.3,90.1,220.3,90.3,213.2,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.8,8.9c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4 C177.4,7.8,178.5,8.9,179.8,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54,197.4V208"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.7,202.7h10.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.6,259.7c50.1,0,90.7-2.5,90.7-5.7c0-3.1-40.6-5.7-90.7-5.7c-50.1,0-90.7,2.5-90.7,5.7 C73,257.1,113.6,259.7,163.6,259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M236.5,193.4H79.9c-1,0-2.1-0.2-3-0.7c-1-0.4-1.8-1.1-2.5-1.9c-0.7-0.8-1.2-1.7-1.5-2.7 c-0.3-1-0.3-2.1-0.2-3.1l20-121.5c0.3-1.7,1.1-3.2,2.4-4.3c1.3-1.1,3-1.7,4.7-1.7h156.6c1,0,2.1,0.2,3,0.7c0.9,0.4,1.8,1.1,2.5,1.9 c0.7,0.8,1.2,1.8,1.5,2.7c0.3,1,0.3,2.1,0.2,3.1l-19.9,121.5c-0.3,1.7-1.2,3.2-2.5,4.3C239.9,192.8,238.3,193.4,236.5,193.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M238.5,54.3l-93-41.5c-2.7-1.2-6,0-7.2,2.7l-29.5,66c-1.2,2.7,0,6,2.7,7.2l93,41.5c2.7,1.2,6,0,7.2-2.7 l29.5-66C242.4,58.7,241.2,55.5,238.5,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M159.1,67.1c2.4-3.4,6-5.9,10.1-7c4.1-1.1,8.4-0.8,12.2,0.9c3.9,1.7,7,4.7,8.9,8.5c1.9,3.8,2.4,8.1,1.5,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M203.6,63.3c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5 C201,62.2,202.2,63.3,203.6,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M166.7,46.9c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5 C164.2,45.8,165.3,46.9,166.7,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M235.8,193.4H78.4c-1.9,0-3.7-0.8-5.1-2.1c-1.4-1.4-2.1-3.2-2.1-5.1v-111c0-1,0.1-1.9,0.5-2.8 c0.4-0.9,0.9-1.7,1.6-2.4c0.7-0.7,1.5-1.3,2.4-1.6c0.9-0.4,1.8-0.6,2.8-0.6h57.3c1.3,0,2.6,0.4,3.8,1.1c1.1,0.7,2.1,1.7,2.7,2.9 l8.2,16c0.6,1.2,1.5,2.2,2.7,2.9c1.1,0.7,2.4,1.1,3.8,1.1h79c1.9,0,3.7,0.8,5.1,2.1c1.4,1.3,2.1,3.2,2.1,5.1v87.3 c0,1.9-0.8,3.8-2.1,5.1C239.6,192.6,237.8,193.4,235.8,193.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M211.6,95.4c-9.1,0-18,2.7-25.5,7.7c-7.6,5.1-13.5,12.2-16.9,20.6c-3.5,8.4-4.4,17.6-2.6,26.6 c1.8,8.9,6.1,17.1,12.6,23.6c6.4,6.4,14.6,10.8,23.5,12.6c8.9,1.8,18.2,0.9,26.6-2.6c8.4-3.5,15.6-9.4,20.6-16.9 c5.1-7.6,7.7-16.5,7.7-25.5c0-12.2-4.8-23.9-13.5-32.5S223.8,95.4,211.6,95.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.3,174.7l12.3,12.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.2,181l-3.8,4c-1.7,1.8-1.6,4.6,0.1,6.3l33,31.6c1.8,1.7,4.6,1.7,6.3-0.1l3.8-4c1.7-1.8,1.6-4.6-0.1-6.3 l-33-31.6C259.7,179.2,256.9,179.2,255.2,181z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.6,6.5v10.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.3,11.8h10.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/no-result.05d6dc3994c4b14ccb3e141f86bbee80.svg";
export { ForwardRef as ReactComponent };